import api from "./api";

// 训练营列表
export const postCampList = params => {
  return api('post', `/v1/management/training-camp/list`, params);
};

// 训练营详情
export const getCampDetails = params => {
  return api('get', `/v1/management/training-camp/campDetails/${params}`);
};

// 训练营新增
export const postCampAdd = params => {
  return api('post', `/v1/management/training-camp/create`, params);
};

// 训练营更新
export const postCampEdit = params => {
  return api('post', `/v1/management/training-camp/edit`, params);
};

// 训练营删除
export const getCampDelete = params => {
  return api('get', `/v1/management/training-camp/delete/${params}`);
};

// 导入训练营报名名单
export const postEnrollmentListUp = formData => {
  return api('post', `/v1/management/training-camp/uploadEnrollmentList`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// 导出训练营报名名单
export const getEnrollmentListDown = params => {
  return api('get', `/v1/management/training-camp/exportEnrollmentList/${params}`,
    {},
    {
      responseType: "blob",
    });
};

// 开营
export const getCampOpen = params => {
  return api('get', `/v1/management/training-camp/open/${params}`);
};

// 上架
export const getCampPublish = params => {
  return api('get', `/v1/management/training-camp/publish/${params}`);
};

// 下架
export const getCampSoldOut = params => {
  return api('get', `/v1/management/training-camp/sold-out/${params}`);
};
// 下载打卡记录
export const campClockExportList = (params) => {
  return api("get", `/v1/management/training-camp/campClockExportList/${params}`, {},
    {
      responseType: "blob",
    });
};
